import React, { useContext, useEffect, useState } from "react";
import SettingSideBar from "./SettingSideBar";
import "./Setting.css";
import NewSidebar from "../newSideBar";
import Navbar from "../NavBar";
import { MyContext } from "../Context/SharedStateContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Menu } from "lucide-react";

const DisplayRule = () => {
  // States for checkboxes and other inputs
  const {
    checkboxes,
    setCheckboxes,
    timerOption,
    setTimerOption,
    scrollOption,
    setScrollOption,
    element,
    setElement,
    deviceSelection,
    setDeviceSelection,
    pageSelection,
    setPageSelection,
    selectedPages,
    setSelectedPages,
    cartValueSelection,
    setCartValueSelection,
    specificCartValue,
    setSpecificCartValue,
    numInputBoxes,
    setNumInputBoxes,
    amounts,
    setAmounts,
    countrySelection,
    setCountrySelection,
    selectedCountries,
    setSelectedCountries,
  } = useContext(MyContext);

  const [countries] = useState(["USA", "Canada", "India", "UK", "Germany"]);
  const [searchValue, setSearchValue] = useState("");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  
    const [isSaving, setIsSaving] = useState(false);

  const localURL = localStorage.getItem("shopURL");

  const headers = {
    "Content-Type": "application/json",
    "x-shop-url": localURL,
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth <= 768) {
        setIsSidebarCollapsed(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const bootstrap = require("bootstrap");
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Handler functions
  const handleCheckboxChange = (e) => {
    setCheckboxes({
      ...checkboxes,
      [e.target.name]: e.target.checked,
    });
  };

  const handleTimerOptionChange = (e) => setTimerOption(e.target.value);
  const handleScrollOptionChange = (e) => setScrollOption(e.target.value);
  const handleDeviceSelectionChange = (e) => setDeviceSelection(e.target.value);
  const handlePageSelectionChange = (e) => setPageSelection(e.target.value);

  const handlePageDropdownChange = (e) => {
    if (e.target.value && !selectedPages.includes(e.target.value)) {
      setSelectedPages([...selectedPages, e.target.value]);
    }
  };

  const removeItem = (index) => {
    const updatedPages = [...selectedPages];
    updatedPages.splice(index, 1);
    setSelectedPages(updatedPages);
  };

  const handleCartValueSelectionChange = (e) =>
    setCartValueSelection(e.target.value);

  const handleSpecificCartValueChange = (e) => {
    setSpecificCartValue(e.target.value);
    setNumInputBoxes(e.target.value === "between" ? 2 : 1);
    setAmounts([""]);
  };

  const handleInputChange = (index, value) => {
    const updatedAmounts = [...amounts];
    updatedAmounts[index] = value;
    setAmounts(updatedAmounts);
  };

  const handleCountrySelectionChange = (e) =>
    setCountrySelection(e.target.value);

  const handleSelectChange = (e) => {
    const selectedCountry = e.target.value;
    if (selectedCountry && !selectedCountries.includes(selectedCountry)) {
      setSelectedCountries([...selectedCountries, selectedCountry]);
    }
  };

  const handleDelete = (country) => {
    setSelectedCountries(selectedCountries.filter((item) => item !== country));
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const displayRule = {
        checkboxes,
        timerOption,
        scrollOption,
        element,
        pageSelection,
        deviceSelection,
        selectedPages,
        cartValueSelection,
        specificCartValue,
        numInputBoxes,
        amounts,
        countrySelection,
        selectedCountries,
      };
      const response = await fetch(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/save-display-rules`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify({ displayRule }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save appearance settings");
      }
      // Show success notification
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error("Error Saving Display Rule", error);
      setShowError(true);
      setTimeout(() => setShowError(false), 3000);
    }finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d-flex flex-column w-100">
      <Navbar />
      <div className="d-flex">
        <NewSidebar />
        <div style={{ display: "flex", flex: 1 }}>
          <SettingSideBar />
          {/* Main Content */}
          <div
            className={`main-setting-container ${
              isSidebarCollapsed ? "sidebar-collapsed" : ""
            }`}
          >
            <div className="setting-header">
              <h3 className="chat-title">Display Rules</h3>
              <p className="setting-subtitle">
                Configure when and where your chat widget should appear
              </p>
            </div>

            <div className="settings-grid">
              {/* When to Show (Triggers) */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    When to Show (Triggers)
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Define when the chat should appear based on user interaction."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>

                <div className="d-flex flex-column mt-2">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      name="showOnTimer"
                      checked={checkboxes.showOnTimer}
                      onChange={handleCheckboxChange}
                    />
                    <span className="checkbox-custom"></span>
                    Show on a Timer
                  </label>
                  {checkboxes.showOnTimer && (
                    <select
                      className="form-select"
                      value={timerOption}
                      onChange={handleTimerOptionChange}
                    >
                      <option value="immediately">Immediately</option>
                      <option value="5s">After 5 seconds</option>
                      <option value="10s">After 10 seconds</option>
                    </select>
                  )}
                </div>

                <div className="d-flex flex-column mt-2">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      name="showAfterScrolling"
                      checked={checkboxes.showAfterScrolling}
                      onChange={handleCheckboxChange}
                    />
                    <span className="checkbox-custom"></span>
                    Show after scrolling
                  </label>
                  {checkboxes.showAfterScrolling && (
                    <select
                      className="form-select"
                      value={scrollOption}
                      onChange={handleScrollOptionChange}
                    >
                      <option value="25">25% of the page</option>
                      <option value="50">50% of the page</option>
                      <option value="75">75% of the page</option>
                      <option value="100">100% of the page</option>
                    </select>
                  )}
                </div>

                <div className="d-flex flex-column mt-2">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      name="showOnExitIntent"
                      checked={checkboxes.showOnExitIntent}
                      onChange={handleCheckboxChange}
                    />
                    <span className="checkbox-custom"></span>
                    Show on exit intent
                  </label>
                </div>

                <div className="d-flex flex-column mt-2">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      name="showOnHtmlElementClick"
                      checked={checkboxes.showOnHtmlElementClick}
                      onChange={handleCheckboxChange}
                    />
                    <span className="checkbox-custom"></span>
                    Show on HTML element click
                  </label>
                  {checkboxes.showOnHtmlElementClick && (
                    <input
                      className="form-input"
                      type="text"
                      placeholder="Enter element ID or class"
                      value={element}
                      onChange={(e) => setElement(e.target.value)}
                    />
                  )}
                </div>
              </div>

              {/* Device */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Device
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Select the devices where the chat should be displayed."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <select
                  className="form-select"
                  value={deviceSelection}
                  onChange={handleDeviceSelectionChange}
                >
                  <option value="allDevices">All Devices</option>
                  <option value="mobile">Mobile</option>
                  <option value="desktop">Desktop</option>
                </select>
              </div>

              {/* Pages */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Pages
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Choose the pages where the chat should be shown."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <select
                  className="form-select"
                  value={pageSelection}
                  onChange={handlePageSelectionChange}
                >
                  <option value="allPages">All Pages</option>
                  <option value="specificPages">Specific Pages</option>
                </select>

                {pageSelection === "specificPages" && (
                  <div className="mt-3">
                    <select
                      className="form-select"
                      onChange={handlePageDropdownChange}
                    >
                      <option value="">Select Page</option>
                      <option value="home">Home</option>
                      <option value="product">Product</option>
                      <option value="cart">Cart</option>
                    </select>
                    <div className="selected-items-container mt-2">
                      {selectedPages.map((page, index) => (
                        <div className="selected-item" key={index}>
                          {page}
                          <button
                            className="delete-item-btn"
                            onClick={() => removeItem(index)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Cart Value */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Cart Value
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Set the cart value conditions for displaying the chat."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <select
                  className="form-select"
                  value={cartValueSelection}
                  onChange={handleCartValueSelectionChange}
                >
                  <option value="anyCartValue">Any Cart Value</option>
                  <option value="specificCartValue">Specific Cart Value</option>
                </select>

                {cartValueSelection === "specificCartValue" && (
                  <div className="mt-3">
                    <select
                      className="form-select"
                      value={specificCartValue}
                      onChange={handleSpecificCartValueChange}
                    >
                      <option value="greaterOrEqualTo">
                        Greater or Equal To
                      </option>
                      <option value="lessOrEqualTo">Less or Equal To</option>
                      <option value="between">Between</option>
                    </select>
                    <div className="input-group-container mt-2">
                      {Array.from({ length: numInputBoxes }).map((_, index) => (
                        <input
                          key={index}
                          className="form-input"
                          type="number"
                          placeholder={
                            index === 0 ? "Min amount" : "Max amount"
                          }
                          value={amounts[index] || ""}
                          onChange={(e) =>
                            handleInputChange(index, e.target.value)
                          }
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Country */}
              <div className="setting-card">
                <div className="setting-card-header">
                  <h4 className="setting-label">
                    Country
                    <span
                      className="ms-2 info-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Choose the countries where the chat should be displayed."
                    >
                      <i className="bi bi-info-circle"></i>
                    </span>
                  </h4>
                </div>
                <select
                  className="form-select"
                  value={countrySelection}
                  onChange={handleCountrySelectionChange}
                >
                  <option value="allCountries">All Countries</option>
                  <option value="specificCountries">Specific Countries</option>
                </select>

                {countrySelection === "specificCountries" && (
                  <div className="mt-3">
                    <input
                      className="form-input"
                      type="text"
                      placeholder="Search countries"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <select
                      className="form-select mt-2"
                      onChange={handleSelectChange}
                    >
                      <option value="">Select country</option>
                      {countries
                        .filter((country) =>
                          country
                            .toLowerCase()
                            .includes(searchValue.toLowerCase())
                        )
                        .map((country, index) => (
                          <option key={index} value={country}>
                            {country}
                          </option>
                        ))}
                    </select>
                    <div className="selected-items-container mt-2">
                      {selectedCountries.map((country, index) => (
                        <div className="selected-item" key={index}>
                          {country}
                          <button
                            className="delete-item-btn"
                            onClick={() => handleDelete(country)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

             {/* Save Button */}
             <div className="save-button-container">
              <button
                onClick={handleSave}
                disabled={isSaving}
                className={`save-button ${isSaving ? "saving" : ""}`}
              >
                {isSaving ? (
                  <>
                    <span className="spinner"></span>
                    Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </button>
            </div>
          </div>
        </div>
        {showSuccess && (
          <div className="notification success-notification">
            <svg viewBox="0 0 24 24" className="notification-icon">
              <path
                fill="currentColor"
                d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
              />
            </svg>
            <span>Settings saved successfully!</span>
          </div>
        )}

        {/* Error Notification */}
        {showError && (
          <div className="notification error-notification">
            <svg viewBox="0 0 24 24" className="notification-icon">
              <path
                fill="currentColor"
                d="M13 13H11V7H13M13 17H11V15H13M12 2C6.47 2 2 6.5 2 12S6.47 22 12 22 22 17.5 22 12 17.53 2 12 2Z"
              />
            </svg>
            <span>Error saving settings. Please try again.</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayRule;
